/**
 * Copyright 2025 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */
import type { ParsedUrlQuery } from 'querystring';

export function normalizeQueryParam(param?: string | string[]) {
  if (Array.isArray(param)) {
    return param.join(',') || '';
  }
  return param || '';
}

export const normalizeQueryParams = (query: ParsedUrlQuery) => {
  const normalizedQuery: Record<string, string | undefined> = {};

  Object.keys(query).forEach((key) => {
    normalizedQuery[key] = normalizeQueryParam(query[key]);
  });

  return normalizedQuery;
};
